import React from 'react'

interface RenderTableProps {
  children?: React.ReactNode
  [key: string]: any
}

const RenderTable = ({ children, ...props }: RenderTableProps) => {
  return (
    <div className="overflow-x-auto my-4 rounded-2xl">
      <table 
        className="min-w-full border border-gray-200 rounded-2xl [&_thead]:bg-gray-50 [&_th]:px-4 [&_th]:py-2 [&_th]:text-sm [&_th]:font-semibold [&_th]:text-gray-900 [&_th]:border-r [&_th]:border-gray-200 [&_th:last-child]:border-r-0 [&_td]:px-4 [&_td]:py-2 [&_td]:text-sm [&_td]:text-gray-700 [&_td]:border-r [&_td]:border-gray-200 [&_td:last-child]:border-r-0 [&_tr]:hover:bg-gray-50 [&_tbody]:divide-y [&_tbody]:divide-gray-200" 
        {...props}
      >
        {children}
      </table>
    </div>
  )
}

export default RenderTable 